import styled from "styled-components";

export const Layout = styled.div`
  gap: 1rem;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 1rem;

  ${({theme}) => theme.breakpoints.up("md")} {
    padding: unset;
    padding-top: unset;
    align-items: center;
    justify-content: center;
  }
`;

export const Container = styled.div`
  width: 95%;
  height: 100%;
  display: grid;
  overflow: hidden;
  grid-template-columns: 1fr;
  grid-template-rows: 110px 1fr;
  border-radius: 10px 10px 0 0;

  ${({theme}) => theme.breakpoints.up("md")} {
    width: 100%;
    border-radius: unset;
    grid-template-rows: unset;
    grid-template-columns: 0.8fr 1fr;
  }
  ${({theme}) => theme.breakpoints.up("lg")} {
    grid-template-columns: 1fr 500px;
  }
`;

export const Welcome = styled.div`
  position: relative;
  background-color: ${({theme}) => theme["primary"]};
`;

export const Information = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Cover = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
